import styled, { css } from 'styled-components';

import {
    Spacer,
    spaceMixin,
    Text,
    token,
} from '@zillow/constellation';
import { Link } from '@zillow/zrs-comet';

export const StyledControlsSpacer = styled(Spacer)`
    border-top: 1px solid ${token('colors.gray300')};
`;

export const StyledLink = styled(Link)`
    margin-left: ${spaceMixin('sm')};
`;

export const StyledSwitchContainerDiv = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    ${props => props.theme.ns().media.md(css`
        justify-content: flex-end;
    `)};
`;

export const StyledText = styled(Text)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const StyledEmphasizeText = styled(StyledText)`
    && {
        font-weight: 600;
    }
`;

export const StyledUnitCardDiv = styled.div`
    border: 1px solid ${token('colors.gray300')};
    border-bottom: 3px solid ${token('colors.blue400')};
    border-radius: 4px;
    background-color: ${token('colors.white')};
`;
